<form [formGroup]="gameRecordFormBase" class="objects-form mb-2" style="height: 72vh; overflow-y: auto;">

    <div class="shared-access-hint" *ngIf="contextAccess !== 'owner'">
        <mat-icon>info_outline</mat-icon>
        <span *ngIf="isViewOnly">{{'GR_view_only' | translate}}</span>
        <span *ngIf="!isViewOnly">{{'GR_shared_info' | translate}}</span>
    </div>

    @if(laboratorySamples?.length!=0){
        @if(!checkAnyRed && !checkAnyYellow && checkAllGreen){
            <div class="p-3 m-1 rounded" style="background-color: rgba(46, 211, 46, 0.671);">
                <span>{{'FORM.gameRecordForm.labSamples.green' | translate}}</span>
            </div>
        }

        @if(!checkAnyRed && checkAnyYellow){
            <div class="p-3 m-1 rounded" style="background-color: rgba(255, 255, 0, 0.3);">
                <span>{{'FORM.gameRecordForm.labSamples.yellow' | translate}}</span>
            </div>
        }

        @if(checkAnyRed && !allLSskippedSubmission && !checkSampleRejected){
            <div class="p-3 m-1 rounded" style="background-color: rgba(255, 0, 0, 0.6);">
                <span>{{'FORM.gameRecordForm.labSamples.red' | translate}}</span>
            </div>
        }

        @if(checkAnyRed && checkAnyPendingSubmission){
            <div class="p-3 m-1 rounded" style="background-color: rgba(255, 0, 0, 0.6);">
                <span>{{'FORM.gameRecordForm.labSamples.pendingSubmission' | translate}}</span>
            </div>
        }

        @if(anyLSskippedSubmission){
            <div class="p-3 m-1 rounded" [style.backgroundColor]="allLSskippedSubmission ? 'rgba(255, 0, 0, 0.6)' : '#8080802b'">
                <span>{{'FORM.gameRecordForm.labSamples.skippedSubmission' | translate}}</span>
            </div>
        }

        @if(checkAuthFailed){
           <div class="p-3 m-1 rounded" style="background-color: rgba(255, 0, 0, 0.6);">
                <span>{{'FORM.gameRecordForm.labSamples.authenticationFailed' | translate}}</span>
            </div>
        }

        @if(checkSampleRejected){
            <div class="p-3 m-1 rounded" style="background-color: rgba(255, 0, 0, 0.6);">
                <span>{{'FORM.gameRecordForm.labSamples.sampleRejected' | translate}}  {{checkSampleRejected?.rejectedMessage ?? '-'}} </span>
            </div>
        }
    }@else{
        @if((hi_tier || nvTrichinella) && (wildart === "Schwarzwild" || wildart === "Dachs") && (district?.nvTrichinellaActive || district?.hiTierActive)){
            <div class="p-3 m-1 rounded" style="background-color: rgba(255, 0, 0, 0.6);">
                <span>{{'FORM.gameRecordForm.labSamples.submissionFailed' | translate}}</span>
            </div>
        }
    }
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.tagid' | translate}}</mat-label>
        <input formControlName="tagid" matInput type="text">
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.officialGameTag' | translate}}</mat-label>
        <input formControlName="officialGameTag" matInput type="text">
    </mat-form-field>

    <div class="section-header">{{'FORM.gameRecordForm.titleSpecies' | translate}}</div>
    <my-btn-species [species]="species" [gameRecord]="data.data" (click)="subFormHandle('species')"></my-btn-species>

    <div class="section-header">{{'FORM.gameRecordForm.titleErleger' | translate}}</div>
    <my-btn-generic [displayData]="displayDataErlegerBtn" (click)="subFormHandle('erleger')"></my-btn-generic>

    <div class="section-header">{{'FORM.gameRecordForm.titleDetails' | translate}}</div>
    <div [class.geo-locked]="isSubFormLocked('districts')">
        <my-btn-generic [displayData]="displayDataHuntignDistrictBtn" (click)="subFormHandle('districts')"></my-btn-generic>
    </div>

    <div matRipple class="d-flex justify-content-between pl-killing"
         [class.geo-locked]="isSubFormLocked('hunterLocation')"
         (click)="subFormHandle('hunterLocation')">
        <div style="align-self: center;">{{'FORM.gameRecordForm.hunterLocation' | translate}}</div>
        <div>
            <div *ngIf="data.data?.hunterLocation?.location != undefined" class="d-flex" style="align-items: center;">
                <div style="align-self: center;">
                    [{{formatNumber(data.data?.hunterLocation?.location.latitude)}}, {{formatNumber(data.data?.hunterLocation?.location.longitude)}}]
                </div>
                <button type="button" mat-icon-button (click)="showLocation(data.data?.hunterLocation?.location)" matTooltip="{{'FORM.BTN_SHOW_ON_MAP' | translate}}">
                    <mat-icon>location_on</mat-icon>
                </button>
            </div>
            <div *ngIf="data.data?.hunterLocation?.location == undefined" class="d-flex" style="align-items: center;">
                <div style="margin: 15px;"> {{'SHARED.NO_DATA'|translate}} </div>
            </div>
        </div>
    </div>

    <div matRipple class="d-flex justify-content-between pl-killing"
         [class.geo-locked]="isSubFormLocked('placeOfKilling')"
         (click)="subFormHandle('placeOfKilling')">
        <div style="align-self: center;">{{'FORM.gameRecordForm.placeOfKilling' | translate}}</div>
        <div>
            <div *ngIf="data.data?.placeOfKilling?.location != undefined" class="d-flex" style="align-items: center;">
                <div style="align-self: center;">
                    [{{formatNumber(data.data?.placeOfKilling?.location.latitude)}}, {{formatNumber(data.data?.placeOfKilling?.location.longitude)}}]
                </div>
                <button type="button" mat-icon-button> <mat-icon>location_on</mat-icon></button>
            </div>
            <div *ngIf="data.data?.placeOfKilling?.location == undefined" class="d-flex" style="align-items: center;">
                <div style="margin: 15px;"> {{'SHARED.NO_DATA'|translate}} </div>
            </div>
        </div>
    </div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.erlegeArt' | translate}}</mat-label>
        <mat-select formControlName="erlegeArt">
            <mat-option *ngFor="let method of dropdownHuntingMethod" [value]="method.identifier">{{method.title}}</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="d-flex flex-row">
        <div class="w-25" style="align-self: center; padding-right: 10px;"> {{'FORM.gameRecordForm.killingDateTime' | translate}}</div>
        <div class="w-75">
            <mat-form-field class="w-50 pr-1">
                <mat-label>{{'FORM.gameRecordForm.killingDate' | translate}}</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="killingDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
        
            <mat-form-field class="w-50 pl-1">
                <mat-label>{{'FORM.gameRecordForm.killingTime' | translate}}</mat-label>
                <input id="timeBox" #timeBox formControlName="killingTime" matInput type="time">
            </mat-form-field>
        </div>
    </div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.ageInYears' | translate}}</mat-label>
        <input formControlName="ageInYears" matInput type="text">
        <div matSuffix>{{'FORM.gameRecordForm.hint_in_years' | translate}}</div>
        <mat-error *ngIf="gameRecordFormBase.controls.ageInYears.errors?.notANumber">{{'FORM_VALIDATION.NaN' | translate}}</mat-error>
    </mat-form-field>

    <div class="section-header">{{'FORM.gameRecordForm.titleStatus' | translate}}</div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.status' | translate}}</mat-label>
        <mat-select formControlName="status">
            <mat-option *ngFor="let status of dropdownStatus" [value]="status.identifier">{{status.title}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.currentLocationID' | translate}}</mat-label>
        <mat-select formControlName="currentLocationID">
            <mat-option *ngFor="let location of dropdownLocation" [value]="location.identifier">{{location.title}}</mat-option>
        </mat-select>
    </mat-form-field>


    <div class="my-1" *ngIf="laboratorySamples">
        <div class="section-header text-uppercase">{{'FORM.gameRecordForm.samples' | translate}}</div>

        <div class="list-group">
            <div *ngFor="let sample of laboratorySamples; let index = index" >
                <!-- <span><strong>{{sample?.type ? sample?.type : ''}}</strong></span><br>
                <span>{{sample?.nvState ? sample?.nvState : ''}}</span> -->
                <my-btn-generic [displayData]="displayDataLabSampleBtn[index]" (click)="subFormHandle('laboratorySamples', sample)"></my-btn-generic>

                <!-- @if(sample.examinations){
                    <div *ngFor="let exam of sample.examinations; let index = index" class="ml-2 p-1" >
                        <span class="p-1 rounded-pill mr-1" [style.background-color]="exam.result ? (exam.result === 'positiv' ? 'rgb(255 0 0 / 50%)' : (exam.result === 'negativ' ? 'rgb(0 128 0 / 50%)' : 'rgb(128 128 128 / 50%)')) : 'rgb(128 128 128 / 50%)'" style="font-size: 10px;line-height: 2;">{{exam?.examinationDisease}}</span>
                    </div>
                } -->

            </div>

        </div>
    </div>

    <!-- <my-btn-generic [displayData]="displayShotQualityBtn"></my-btn-generic>
    <my-btn-generic [displayData]="displayMeatQualityBtn"></my-btn-generic> -->
    <div class="d-flex">
        <button mat-icon-button (click)="displayInfo('FORM.gameRecordForm.shotQuality', shotQualityOptions)">
            <mat-icon>info</mat-icon>
        </button>
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.gameRecordForm.shotQuality' | translate}}</mat-label>
            <mat-select formControlName="shotQuality">
                <mat-option *ngFor="let el of shotQualityOptions" [value]="el.identifier">{{el.title}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="d-flex">
        <button mat-icon-button (click)="displayInfo('FORM.gameRecordForm.meatQuality', meatQualityOptions)">
            <mat-icon>info</mat-icon>
        </button>
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.gameRecordForm.meatQuality' | translate}}</mat-label>
            <mat-select formControlName="meatQuality">
                <mat-option *ngFor="let el of meatQualityOptions" [value]="el.identifier">{{el.title}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="postMortemInspectionRequired">
        {{'FORM.gameRecordForm.postMortemInspectionRequired' | translate}}
    </mat-slide-toggle>

    <div [hidden]="!showPostMortemComment">
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.gameRecordForm.comment' | translate}}</mat-label>
            <textarea formControlName="postMortemInspectionComment" matInput></textarea>
        </mat-form-field>
    </div>

    <div>
        <div class="section-header">{{'FORM.gameRecordForm.titleWeights' | translate}}</div>

        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.gameRecordForm.dressedPreliminary' | translate}}</mat-label>
            <input formControlName="dressedPreliminary" matInput type="text">
            <div matSuffix>KG</div>
            <mat-error *ngIf="gameRecordFormBase.controls.dressedPreliminary.errors?.notANumber">{{'FORM_VALIDATION.NaN' | translate}}</mat-error>
        </mat-form-field>
    
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.gameRecordForm.salesAsWholeBody' | translate}}</mat-label>
            <input formControlName="salesAsWholeBody" matInput type="text">
            <div matSuffix>KG</div>
            <mat-error *ngIf="gameRecordFormBase.controls.salesAsWholeBody.errors?.notANumber">{{'FORM_VALIDATION.NaN' | translate}}</mat-error>
        </mat-form-field>
    </div>

    <div class="section-header">{{'FORM.gameRecordForm.titleUtilization' | translate}}</div>
    <my-btn-generic [displayData]="displayPlannedUtilization" (click)="subFormHandle('uitilization')"></my-btn-generic>

    <mat-slide-toggle class="example-margin slide-toggle-text" formControlName="hasShootPrice">
        {{'FORM.gameRecordForm.hasShootPrice' | translate}}
    </mat-slide-toggle>

    <div [hidden]="!showHasShotPrice">
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.gameRecordForm.shootPrice' | translate}}</mat-label>
            <input formControlName="shootPrice" matInput type="text">
            <div matSuffix>€</div>
            <mat-error *ngIf="gameRecordFormBase.controls.shootPrice.errors?.notANumber">{{'FORM_VALIDATION.NaN' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.gameRecordForm.receiptNo' | translate}}</mat-label>
            <input formControlName="receiptNo" matInput type="text">
        </mat-form-field>
    </div>

    <my-btn-generic [displayData]="displayHuntingEvent" (click)="subFormHandle('events')"></my-btn-generic>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.postingAccount' | translate}}</mat-label>
        <input formControlName="postingAccount" matInput type="text">
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput></textarea>
    </mat-form-field>

    <div class="mb-2 pb-1">
        <div class="section-header text-uppercase mb-1" style="align-self: center;">{{'FORM.gameRecordForm.attatchments' | translate}}</div>
        <div class="list-group">
            <div class="list-group-item" *ngFor="let item of attatchments">
                <a href="{{item.url}}" target="_blank" style="color:var(--primary);"><span style="font-size:14px;">{{item.name}}</span></a>
            </div>
        </div>
        <button [disabled]="gameRecordFormBase.invalid" class="second-btn w-100 my-1" mat-button type="submit" (click)="onGameOriginForm()">
            {{ 'FORM.gameOriginFormDialog.onGameOriginForm' | translate }}
        </button>
    </div>

    <div class="mt-1 mb-1">
        <div class="section-header text-uppercase mb-1" style="align-self: center;">{{'FORM.gameRecordForm.pictures' | translate}}</div>
        <div class="container px-1">
            <div class="row row-cols-auto flex-nowrap"><!--d-flex flex-row-->
                <div class=" col col-6 col-md-4 px-1 mx-1" *ngFor="let picture of gameRecordImages; let index=index" style="max-width: 150px;">
                    <img *ngIf="picture.preview" src="{{picture.preview}}" width="150" height="150" class="rounded" style="object-fit: cover;">
                    <img *ngIf="!picture.preview" src="{{picture.resourceId}}" width="150" height="150" class="rounded" style="object-fit: cover;">
                    <div class="middle">
                        <div class="d-flex flex-row ">
                            <button mat-icon-button class="mx-1" style="background-color: #fff; color: var(--primary);" (click)="openImage(picture, index)">
                                <mat-icon>visibility</mat-icon>
                            </button>

                            <button mat-icon-button class="mx-1" style="background-color: #fff; color: var(--primary);" (click)="deleteImg(picture, index)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-context-rights-picker formControlName="contextIdRights"></app-context-rights-picker>
</form>

<div class="sticky-bottom my-1">
    <button [disabled]="!canSave" class="first-btn w-100 my-1" mat-raised-button type="submit" (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button *ngIf="diwima_adis_module" [disabled]="!canSave" class="second-btn w-100 my-1" mat-raised-button type="button" (click)="onReportWebTSN()">
        {{ 'FORM.BTN_ReportWebTSN' | translate }}
    </button>

    <button [disabled]="!canDelete" class="second-btn w-100 my-1" mat-button type="button" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>